export default __webpack_public_path__ + "static/media/bannerTL.e13dd84b.webp";